import React, { useEffect, useState, useRef } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

import fileicon from "../../picture/file-icon.png";
import AuthService from "../../services/auth.service";

import "./Regulator.css";
import BootstrapTable from "react-bootstrap-table-next";
import * as Cesium from "cesium";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import dayjs from "dayjs";


function RegulatorStatusflightDrone() {
  Cesium.Ion.defaultAccessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4YTkzY2UxMS1kMzE1LTQ5OTgtYjZjYS1lYjQ0ZmI2M2Q5ODMiLCJpZCI6MTAyMzYwLCJpYXQiOjE2NTg3MTU3NzZ9.JRrIwyF6xYiIdmIiP9ezmq4siqacN1K6ObnYnjpfHVc";
  let Navigate = useNavigate();
  const [items, setItems] = useState([
    {
      operation_id: 1,
      operation_code: "AMTO-JWN8R",
      operation_start_time: "2023-03-01 09:15:00",
      operation_end_time: "2023-03-01 11:16:00",
      operation_status_text: "อนุมัติ",
      created_at: "2023-03-01 09:16:53",
      drone_list: "[1]",
      pilot_list: "[1]",
      area: "[100.92694579291616,13.105114583134707,100.9267908413695,13.10170874932099,100.92648113759897,13.09960252742651,100.93019096588586,13.099685464291369,100.93187583325506,13.103565135651818]",
      altitude: 80,
    },
    {
      operation_id: 2,
      operation_code: "AMTO-4UEP8",
      operation_start_time: "2023-03-02 00:00:00",
      operation_end_time: "2023-03-02 03:00:00",
      operation_status_text: "อยู่ระหว่างการพิจารณา",
      created_at: "2023-03-01 09:18:52",
      drone_list: "[1,2]",
      pilot_list: "[1]",
      area: "[100.94144851179259,13.110107473705229,100.93365946736748,13.110372612075563,100.93676430597243,13.10582147586792,100.93932497136674,13.104674047843357,100.94029370758946,13.106260763347313,100.94131751871686,13.106020052458716,100.94248380122013,13.107858462219614]",
      altitude: 75,
    },
    {
      operation_id: 3,
      operation_code: "AMTO-20SQX",
      operation_start_time: "2023-03-03 14:25:00",
      operation_end_time: "2023-03-03 16:01:00",
      operation_status_text: "ไม่อนุมัติ",
      created_at: "2023-03-01 09:44:54",
      drone_list: "[2]",
      pilot_list: "[1]",
      area: "[100.9176127157313,13.12415212733026,100.91720647367727,13.11957150214597,100.91726687405465,13.1158143391076,100.92329748684803,13.115355779685657,100.92373142134046,13.115044759995863,100.9208398972321,13.120857677829191,100.91965905637929,13.124002377064512]",
      altitude: 80,
    },
    {
      operation_id: 4,
      operation_code: "AMTO-W9UQ6",
      operation_start_time: "2023-03-03 12:00:00",
      operation_end_time: "2023-03-03 15:01:00",
      operation_status_text: "อนุมัติ",
      created_at: "2023-03-01 09:45:52",
      drone_list: "[1,2]",
      pilot_list: "[1]",
      area: "[100.92364086390522,13.114968371279064,100.91900716195629,13.119926270253094,100.91736356316252,13.119706756968336,100.91704760589951,13.115460453775226]",
      altitude: 60,
    },
    {
      operation_id: 5,
      operation_code: "-",
      operation_start_time: "2023-03-03 12:00:00",
      operation_end_time: "2023-03-03 15:01:00",
      operation_status_text: "ไม่อนุมัติ",
      created_at: "2023-03-01 09:46:22",
      drone_list: "[1]",
      pilot_list: "[1]",
      area: "[100.92512471197985,13.12782983105395,100.91834887553279,13.132760540707881,100.91769756392657,13.12414501561266]",
      altitude: 65,
    },
    {
      operation_id: 6,
      operation_code: "-",
      operation_start_time: "2023-03-03 12:00:00",
      operation_end_time: "2023-03-03 15:01:00",
      operation_status_text: "อยู่ระหว่างการพิจารณา",
      created_at: "2023-03-01 09:46:56",
      drone_list: "[2]",
      pilot_list: "[1]",
      area: "[100.90146504147198,13.129554372119959,100.90583817251188,13.129571546419518,100.90919666536774,13.132066883230603,100.90669252701555,13.13343745437741,100.91413039491607,13.13433369654221,100.91454843351892,13.12796185311852,100.91534189089738,13.124850898246034,100.91356167697995,13.124120000104003,100.90961710503149,13.126489825007207,100.90769000789123,13.12529550534575,100.90839847618122,13.119684779289392,100.90372252313492,13.118212591910924,100.89983934855567,13.118767232875403,100.89830178159418,13.120583476634954,100.89619320176936,13.120166895113984,100.89566789222968,13.121449499932504,100.89814908902127,13.123521219223948,100.89941476348083,13.127989661121326,100.90162426444427,13.128651941132139]",
      altitude: 80,
    },
    {
      operation_id: 7,
      operation_code: "-",
      operation_start_time: "2023-03-11 13:05:00",
      operation_end_time: "2023-03-11 13:06:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-01 09:47:22",
      drone_list: "[2]",
      pilot_list: "[1]",
      area: "[100.92823531180491,13.115393174622938,100.9270762099564,13.119018462294958,100.92817102329053,13.122712248656967,100.93355672872755,13.12160572331164,100.93812641520717,13.121605662748756,100.93777178040712,13.119753659314084,100.93244203034467,13.117046839427081]",
      altitude: 80,
    },
    {
      operation_id: 8,
      operation_code: "-",
      operation_start_time: "2023-03-08 12:00:00",
      operation_end_time: "2023-03-08 14:11:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-01 09:47:58",
      drone_list: "[1,2]",
      pilot_list: "[1]",
      area: "[100.91384916948398,13.103403602604773,100.9156062327006,13.099965447062251,100.9135949711362,13.09013915836287,100.919050300293,13.074102421194809,100.904746787069,13.070645788209436,100.8895370934965,13.091433564260331,100.89242334208575,13.095231893605717]",
      altitude: 80,
    },
    {
      operation_id: 9,
      operation_code: "-",
      operation_start_time: "2023-03-09 11:59:00",
      operation_end_time: "2023-03-09 13:11:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-01 09:48:24",
      drone_list: "[1,2]",
      pilot_list: "[1]",
      area: "[100.9438034229903,13.110091595394168,100.94371282793217,13.088847985389643,100.95372151286436,13.08971563176468,100.9566363584262,13.112210456783053]",
      altitude: 80,
    },
    {
      operation_id: 10,
      operation_code: "-",
      operation_start_time: "2023-03-06 00:56:00",
      operation_end_time: "2023-03-06 02:50:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-01 09:48:56",
      drone_list: "[1,2]",
      pilot_list: "[1]",
      area: "[100.93209141982176,13.185635119979283,100.93481768586526,13.184296765280672,100.93490805451171,13.182656187895036,100.93613872711711,13.181091303734007,100.9359571218959,13.179956397409779,100.93405028448542,13.178821558209812,100.9327703546401,13.175596642334117,100.93177985671373,13.1758929673416]",
      altitude: 80,
    },
    {
      operation_id: 11,
      operation_code: "-",
      operation_start_time: "2023-03-10 12:15:00",
      operation_end_time: "2023-03-10 14:45:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-08 11:27:49",
      drone_list: "[2]",
      pilot_list: "[1]",
      area: "[100.9237864434534,13.106879959893288,100.92284926847242,13.105585296081705,100.92476726774464,13.105639193489004,100.92519578676463,13.104176611133779,100.92406619812573,13.100557031755807,100.92545495843706,13.10038369806096,100.92565742853593,13.099758480333321,100.92950729929102,13.099662057339026,100.92956394461541,13.100230846060793,100.93050276717292,13.10039147724681,100.9308309204155,13.101420609061455,100.93302951689863,13.101402091591758,100.93466701152856,13.106119698854503,100.93113485026993,13.10709714625055,100.92927241594336,13.109287826844527]",
      altitude: 80,
    },
    {
      operation_id: 12,
      operation_code: "-",
      operation_start_time: "2023-03-10 12:05:00",
      operation_end_time: "2023-03-10 14:46:00",
      operation_status_text: "ส่งอนุมัติ",
      created_at: "2023-03-08 13:37:20",
      drone_list: "[1]",
      pilot_list: "[1]",
      area: "[100.91528174680158,13.10358695312959,100.91437158138879,13.09334118902708,100.92015360882796,13.077254242973513,100.88829111067858,13.056759126924199,100.8848422025666,13.060940373911306,100.89882523928244,13.068624556965622,100.89645367063237,13.073530014094281,100.88262232954476,13.063344785692962,100.87847414382131,13.071282214696138,100.88688686161369,13.076623824760118,100.88312905597711,13.083194742148335,100.8853867904867,13.084448554679202,100.88460208514341,13.085708169069415]",
      altitude: 80,
    },
  ]);
  const mapRef = useRef(null);
  
  const [data, setData] = useState([]);
  
  const [chosenMap, setChosenMap] = useState(1);
  
  const [latitudeLook, setLatitudeLook] = useState(13.105764702696409);
  const [longitudeLook, setLongitudeLook] = useState(100.9407286735396);
  
  const [checkeds, setCheckeds] = useState(false);
  const [showInfomation, setShowInfomation] = useState(false);
  const [allArea, setAllArea] = useState({});
  const [selectedInformation, setSelectedInformation] = useState([]);
  const [approveStage, setApproveStage] = useState("");
  
  const [updatedArray, setUpdatedArray] = useState([]);
  const [o_id, setO_id] = useState();
  // const createPost = (req_num) => {
  //   Navigate("/statusDroneSec", {
  //     state: {
  //       dronereq_id: req_num,
  //     },
  //   });
  // };
  // const editnosuc = (brand_model) => {
  //   Navigate("/statusDroneSec", {
  //     state: {
  //       brand_model: brand_model,
  //     },
  //   });
  // };
  const handleClose = () => {
    setShowInfomation(false);
    setApproveStage("");
  };
  const handleShow = (id, user_id) => {
    getdataonlyone(id, user_id);
    //setShowInfomation(true);
  };
  const handleSendupdate = (status) => {
    console.log(status);
    if (status === "อนุมัติ") {
      updatedataonlyone(o_id, 3);
    } else {
      updatedataonlyone(o_id, 4);
    }
  };
  const handlechange = () => {
    if (chosenMap === 1) {
      setCheckeds(true);
      //console.log(chosenMap);
      setChosenMap(2);
      handleToggleClick();
    } else if (chosenMap === 2) {
      setChosenMap(1);
      setCheckeds(false);
      handleToggleClick1();
      // console.log(chosenMap);
    }
  };
  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    //withFirstAndLast: false, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    //hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    //paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: data.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const getdataonlyone = (id, user_id) => {
    //console.log(updatedArray);
    const operationone = AuthService.getoperationdata(id, user_id);
    operationone.then((response) => {
      console.log(response.data)
      const tempArray = [];

      const tempAreaObj = {};
      for (
        let operationCount = 0;
        operationCount < response.data.data.length;
        operationCount++
      ) {
        tempArray.push(response.data.data[operationCount]);
        // tempAreaObj[response.data.data[operationCount].operation_id] =
        //   JSON.parse(response.data.data[operationCount].area);
        tempAreaObj = JSON.parse(response.data.data.area);
      }
      //console.log(response.data.data.area);
      setItems(tempArray);
      console.log(response);
      setAllArea(response.data.data.area);
      setShowInfomation(true);
    });
  };
  const updatedataonlyone = (id, status) => {
    console.log(status);
    const updateoperationone = AuthService.updateoperationstatus(id, status);
    updateoperationone.then((response) => {
      console.log(response);
      window.location.reload(false);
    });
  };
  const getdata = () => {
    const operationlist = AuthService.getalloperationdata();
    operationlist.then((response) => {
      console.log(response);
      setData(response.data.data[0]);
      //console.log(data);
      // const tempArray = [];

      // const tempAreaObj = {};
      // for (
      //   let operationCount = 0;
      //   operationCount < response.data.data.length;
      //   operationCount++
      // ) {
      //   tempArray.push(response.data.data[operationCount]);
      //   tempAreaObj[response.data.data[operationCount].operation_id] =
      //     JSON.parse(response.data.data[operationCount].area);
      // }
      // console.log(tempArray);
      // //setItems(tempArray);
      // setAllArea(tempAreaObj);
    });
  };
  // const updateArrayWithNewKey = () => {
  //   const newArray = data.map((obj) => {
  //     const newObj = { ...obj };

  //     newObj.id = newObj.operation_id;
  //     newObj.number = newObj.operation_code;
  //     newObj.status = newObj.operation_status_text;
  //     newObj.date = newObj.operation_start_time;
  //     newObj.detail = (
  //       <div>
  //         <button onClick={()=>{
  //         setSelectedInformation([
  //           newObj.id,
  //           newObj.number,
  //           newObj.name,
  //           newObj.date,
  //           newObj.operation_end_time,
  //           newObj.status,
  //           // newObj.drone_list,
  //           // newObj.pilot_list,
  //           // newObj.altitude,
  //         ])
  //         console.log(newObj.id)
  //           handleShow(newObj.id,newObj.user_id)

  //         }
  //         }
  //           >
  //         <img
  //           alt=""
  //           src={fileicon}
  //           style={{ width: "37px", height: "37px" }}

  //         />
  //         </button>
  //       </div>
  //     );
  //     delete newObj.operation_id;
  //     delete newObj.operation_code;
  //     delete newObj.operation_status_text;
  //     delete newObj.operation_start_time;
  //     return newObj;
  //   });
  //   console.log(newArray);
  //   setUpdatedArray(newArray);
  // };
  const updateArrayWithNewKey = () => {
    const newArray = data.map((obj) => {
      const newObj = { ...obj };
      newObj.detail = (
        <div>
          <p
            onClick={() => {
              setSelectedInformation([
                newObj.operation_id,
                newObj.operation_code,
                newObj.name,
                newObj.operation_start_time,
                newObj.operation_end_time,
                newObj.status,
                // newObj.drone_list,
                // newObj.pilot_list,
                // newObj.altitude,
              ]);

              setO_id(newObj.operation_id);
              handleShow(newObj.operation_id, newObj.user_id);
            }}
            style={{cursor: "pointer"}}
          >
            <img
              alt=""
              src={fileicon}
              style={{ width: "37px", height: "37px" }}
            />
          </p>
        </div>
      );
      return newObj;
    });
    console.log(newArray);
    setUpdatedArray(newArray);
  };
  useEffect(() => {
    getdata();
  }, []);
  useEffect(() => {
    updateArrayWithNewKey();
  }, [data]);
  useEffect(() => {
    Cesium.Ion.defaultAccessToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0NWRmNzNlMC1kM2Q2LTQ1NjktOGYyZS05OTgxODY4MjFkMWYiLCJpZCI6MTE0OTM0LCJpYXQiOjE2Njg1MDQyOTd9.tGuqXkgCUHv8RYTUVDyHYJ3o7CAFIP8sToMK-7ROZvc";

    if (showInfomation) {
      const viewer = new Cesium.Viewer(mapRef.current, {
        selectionIndicator: false,
        infoBox: false,
        timeline: false,
        homeButton: false,
        animation: false,
        vrButton: false,
        fullscreenButton: false,

        sceneModePicker: false,
        terrainProvider: Cesium.createWorldTerrain(),
      });
      viewer.entities.removeAll();
      //T
      let purplePolygon = viewer.entities;
      let redPolygon = viewer.entities;
      console.log(allArea);
      const drawPolygon = async () => {
        await Promise.all([
          purplePolygon.add({
            name: "Red polygon on surface",
            polygon: {
              hierarchy: Cesium.Cartesian3.fromDegreesArray(
                //allArea[selectedInformation[0]]
                allArea
              ),
              material: Cesium.Color.PURPLE.withAlpha(0.5),
              extrudedHeight: 80,
            },
          }),
          Object.entries(allArea, allArea).map(([key, content]) => {
            console.log(content);
            if (parseInt(key) !== 7) {
              console.log(content);
              redPolygon.add({
                name: "Red polygon on surface",
                polygon: {
                  hierarchy: Cesium.Cartesian3.fromDegreesArray(content),
                  material: Cesium.Color.RED.withAlpha(0.5),
                  extrudedHeight: 80,
                },
              });
            }
          }),
        ]);
      };
      function intersect(e1, e2) {
        const b1 = new Cesium.BoundingSphere();
        const b2 = new Cesium.BoundingSphere();

        const state1 = viewer._dataSourceDisplay.getBoundingSphere(
          e1,
          false,
          b1
        );

        if (state1 !== Cesium.BoundingSphereState.DONE) {
          return false;
        }

        const state2 = viewer._dataSourceDisplay.getBoundingSphere(
          e2,
          false,
          b2
        );

        if (state2 !== Cesium.BoundingSphereState.DONE) {
          return false;
        }

        const dist = Cesium.Cartesian3.distance(b1.center, b2.center);

        return dist < b1.radius + b2.radius;
      }
      // purplePolygon.add({
      //   name: "Red polygon on surface",
      //   polygon: {
      //     hierarchy: Cesium.Cartesian3.fromDegreesArray(
      //       allArea[selectedInformation[0]]
      //     ),
      //     material: Cesium.Color.PURPLE.withAlpha(0.5),
      //     extrudedHeight: 80,
      //   },
      // });
      // Object.entries(allArea).map(([key, content]) => {
      //   if (parseInt(key) !== selectedInformation[0]) {
      //     redPolygon.add({
      //       name: "Red polygon on surface",
      //       polygon: {
      //         hierarchy: Cesium.Cartesian3.fromDegreesArray(content),
      //         material: Cesium.Color.RED.withAlpha(0.5),
      //         extrudedHeight: 80,
      //       },
      //     });
      //   }
      // });
      const intersectDetect = async () => {
        viewer.entities.removeAll();
        drawPolygon();

        var entities = viewer.entities.values;
        for (var i = 0; i < entities.length; i++) {
          var entity = entities[i];

          console.log(intersect(purplePolygon, entity));
        }
      };
      intersectDetect();
      viewer.zoomTo(purplePolygon);
      return () => {
        viewer.destroy();
      };
    }
  }, [showInfomation]); // Pass an empty array as the second argument to run this effect only once
  //const { state } = useLocation();

  // useEffect(() => {
  //   mapRef.current = new Cesium.Viewer(mapRef.current, {
  //         selectionIndicator: false,
  //         infoBox: false,
  //         timeline: false,
  //         homeButton: false,
  //         animation: false,
  //         vrButton: false,
  //         fullscreenButton: false,
  //         sceneModePicker: false,
  //         useDefaultRenderLoop: true
  //         //terrainProvider: Cesium.createWorldTerrain(),
  //       });

  //   return () => {
  //       mapRef.destroy();

  //   };
  // }, []);

  // useEffect(() => {
  //   const check = AuthService.getalloperationdata();
  //   if (check != null)
  //     AuthService.getalloperationdata().then((response) => {

  //       console.log(response);

  //     });
  // }, []);
  const handleToggleClick = () => {
    mapRef.current = new Cesium.Viewer("ssd", {
      selectionIndicator: false,
      infoBox: false,
      timeline: false,
      homeButton: false,
      animation: false,
      vrButton: false,
      fullscreenButton: false,
      sceneModePicker: false,
      useDefaultRenderLoop: true,
      terrainProvider: Cesium.createWorldTerrain(),
    });
    mapRef.current.camera.lookAt(
      Cesium.Cartesian3.fromDegrees(longitudeLook, latitudeLook, 1000.0),
      new Cesium.Cartesian3(0.0, -3500.0, 3500.0)
    );
  };
  const handleToggleClick1 = () => {
    mapRef.current.destroy();
  };
  const pageStyle = {
    position: "absolute",
    width: "90%",
    height: "86px",
    left: "5%",
    top: "220px",
    background: "linear-gradient(90deg, #023E8A 0%, #0096C7 100%)",
    color: "#FFFFFF",
    textAlign: "center",
    paddingTop: "25px",
    boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    fontSize: "32px",
  };
  const pageStyle2 = {
    position: "absolute",
    width: "90%",
    height: "86px",
    left: "5%",
    top: "1220px",
    background: "linear-gradient(90deg, #023E8A 0%, #0096C7 100%)",
    color: "#FFFFFF",
    textAlign: "center",
    paddingTop: "25px",
    boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    fontSize: "32px",
  };
  // function stateP() {
  //   Navigate("/statusDroneSec");
  // }
  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "operation_id",
      text: "ลำดับ",
      //sort: true,
    },
    {
      dataField: "operation_code",
      text: "เลขที่คำขอ",
    },
    {
      dataField: "name",
      text: "ผู้ขออนุญาต",
    },
    {
      dataField: "operation_status_text",
      text: "สถานะ",
    },
    {
      dataField: "operation_start_time",
      text: "วันที่ปฏิบัติการ",
    },
    {
      dataField: "detail",
      text: "รายละเอียด",
    },
  ];
  const columns2 = [
    {
      dataField: "id",
      text: "ลำดับ",
      //sort: true,
    },
    {
      dataField: "numbrt",
      text: "เลขที่คำขอ",
    },
    {
      dataField: "name",
      text: "ผู้ขออนุญาต",
    },
    {
      dataField: "status",
      text: "สถานะ",
    },
    {
      dataField: "date",
      text: "วันที่ปฏิบัติการ",
    },
    {
      dataField: "detail",
      text: "รายละเอียด",
    },
  ];

  const product = [
    {
      id: "1",
      number: "6df02",
      name: "sd",
      status: "ไม่อนุมัติ",
      date: "08/07/2022",
      detail: (
        <div>
          <img
            alt=""
            src={fileicon}
            style={{ width: "37px", height: "37px" }}
            onClick={() => {
              handlechange();
            }}
          />
        </div>
      ),
    },
    {
      id: "2",
      number: "6df03",
      name: "test2",
      status: "อนุมัติ",
      date: "07/07/2022",
      detail: (
        <div>
          
        </div>
      ),
    },
    {
      id: "3",
      number: "6df04",
      name: "test3",
      status: "อนุมัติ",
      date: "07/07/2022",
      detail: (
        <div>
          
        </div>
      ),
    },
    {
      id: "4",
      number: "6df05",
      name: "test4",
      status: "เกินเวลาที่ขอ",
      date: "07/07/2022",
      detail: (
        <div>
          
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        //className="container"
        style={{ fontFamily: "Kanit", fontSize: "21px" }}
      >
        <div className="menu-container">
          <h2
            style={{
              color: "#0077B6",
              fontSize: "46px",
              position: "absolute",
              width: "456px",
              height: "69px",
              left: "83px",
              top: "137px",
            }}
          >
            รายการปฏิบัติการ
          </h2>
          <div>
            {chosenMap === 1 ? (
              <div className="map">
                <div
                  style={{
                    display: "block",
                    margin: "auto",
                    left: "44%",
                    right: "50%",
                    width: "20%",
                    height: "3.5%",
                    position: "absolute",
                    zIndex: 1,
                    transition: "all 0.3s",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "25px",
                      width: "100%",
                      fontSize: "21px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="toggle-map"
                      className="toggleCheckbox"
                      checked={checkeds}
                      onChange={() => {
                        handlechange();
                        // if (chosenMap === 1) {
                        //   setChosenMap(2);
                        //   handleToggleClick();
                        //   console.log(chosenMap);
                        // } else if (chosenMap === 2) {
                        //   setChosenMap(1);
                        //   handleToggleClick1();
                        //   // console.log(chosenMap);
                        // }
                      }}
                    />
                    {/* <label
                      htmlFor="toggle-map"
                      className="toggleContainer"
                      style={{ margin: "0px", fontSize: "21px" }}
                    >
                      <div>ตาราง</div>
                      <div>แผนที่</div>
                    </label> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="map">
                <div
                  style={{
                    display: "block",
                    margin: "auto",
                    left: "44%",
                    right: "50%",
                    width: "20%",
                    height: "3.5%",
                    position: "absolute",
                    zIndex: 1,
                    transition: "all 0.3s",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "25px",
                      width: "100%",
                      fontSize: "21px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="toggle-map"
                      className="toggleCheckbox"
                      checked={checkeds}
                      onChange={() => {
                        handlechange();
                        // if (chosenMap === 1) {
                        //   setChosenMap(2);

                        //   console.log(chosenMap);
                        // } else if (chosenMap === 2) {
                        //   setChosenMap(1);
                        //   handleToggleClick1();
                        //   console.log(chosenMap);
                        // }
                      }}
                    />
                    <label
                      htmlFor="toggle-map"
                      className="toggleContainer"
                      style={{ margin: "0px", fontSize: "21px" }}
                    >
                      <div>ตาราง</div>
                      <div>แผนที่</div>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <ToolkitProvider
          keyField="id"
          data={updatedArray}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <label
                style={{
                  position: "absolute",
                  width: "96%",

                  left: "2%",
                  top: "250px",
                  background: "#FFFFFF",
                  color: "#FFFFFF",
                  textAlign: "center",
                  paddingTop: "70px",
                  boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.25)",
                  borderRadius: "10px",
                  fontSize: "32px",
                  overflow: "auto",
                  borderTop: "20px",
                }}
              >
                <BootstrapTable
                  {...props.baseProps}
                  bordered={false}
                  style={{ background: "white", top: "120px" }}
                  pagination={paginationFactory(options)}
                />
                
              </label>
              <h4 style={pageStyle}>รายการปฏิบัติการทั้งหมด</h4>
              <h4
                style={{
                  right: "370px",
                  top: "250px",
                  position: "absolute",
                  color: "white",
                }}
              >
                ค้นหา
              </h4>
              <div
                style={{
                  top: "235px",
                  right: "150px",
                  position: "absolute",
                  display: "inline-flex",
                  width: "200px",
                  justifyContent: "center",
                }}
              >
                <SearchBar
                  {...props.searchProps}
                  placeholder="ชื่อ,สถานะ,วันที่,..."
                />
              </div>

              <hr />
            </div>
          )}
        </ToolkitProvider>
        <div>
        <div className="menu-container">
          
          <div>
            {chosenMap === 1 ? (
              <div className="map">
                <div
                  style={{
                    display: "block",
                    margin: "auto",
                    left: "44%",
                    right: "50%",
                    width: "20%",
                    height: "3.5%",
                    position: "absolute",
                    zIndex: 1,
                    transition: "all 0.3s",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "25px",
                      width: "100%",
                      fontSize: "21px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="toggle-map"
                      className="toggleCheckbox"
                      checked={checkeds}
                      onChange={() => {
                        handlechange();
                        // if (chosenMap === 1) {
                        //   setChosenMap(2);
                        //   handleToggleClick();
                        //   console.log(chosenMap);
                        // } else if (chosenMap === 2) {
                        //   setChosenMap(1);
                        //   handleToggleClick1();
                        //   // console.log(chosenMap);
                        // }
                      }}
                    />
                    {/* <label
                      htmlFor="toggle-map"
                      className="toggleContainer"
                      style={{ margin: "0px", fontSize: "21px" }}
                    >
                      <div>ตาราง</div>
                      <div>แผนที่</div>
                    </label> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="map">
                <div
                  style={{
                    display: "block",
                    margin: "auto",
                    left: "44%",
                    right: "50%",
                    width: "20%",
                    height: "3.5%",
                    position: "absolute",
                    zIndex: 1,
                    transition: "all 0.3s",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "25px",
                      width: "100%",
                      fontSize: "21px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="toggle-map"
                      className="toggleCheckbox"
                      checked={checkeds}
                      onChange={() => {
                        handlechange();
                        // if (chosenMap === 1) {
                        //   setChosenMap(2);

                        //   console.log(chosenMap);
                        // } else if (chosenMap === 2) {
                        //   setChosenMap(1);
                        //   handleToggleClick1();
                        //   console.log(chosenMap);
                        // }
                      }}
                    />
                    <label
                      htmlFor="toggle-map"
                      className="toggleContainer"
                      style={{ margin: "0px", fontSize: "21px" }}
                    >
                      <div>ตาราง</div>
                      <div>แผนที่</div>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <ToolkitProvider
          keyField="id"
          data={product}
          columns={columns2}
          search
        >
          {(props) => (
            <div>
              <label
                style={{
                  position: "absolute",
                  width: "96%",

                  left: "2%",
                  top: "1250px",
                  background: "#FFFFFF",
                  color: "#FFFFFF",
                  textAlign: "center",
                  paddingTop: "70px",
                  boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.25)",
                  borderRadius: "10px",
                  fontSize: "32px",
                  overflow: "auto",
                  borderTop: "20px",
                }}
              >
                <BootstrapTable
                  {...props.baseProps}
                  bordered={false}
                  style={{ background: "white", top: "120px" }}
                  pagination={paginationFactory(options)}
                />
                
              </label>
              <h4 style={pageStyle2}>รายการปฏิบัติการทั้งหมด</h4>
              <h4
                style={{
                  right: "370px",
                  top: "1250px",
                  position: "absolute",
                  color: "white",
                }}
              >
                ค้นหา
              </h4>
              <div
                style={{
                  top: "1235px",
                  right: "150px",
                  position: "absolute",
                  display: "inline-flex",
                  width: "200px",
                  justifyContent: "center",
                }}
              >
                <SearchBar
                  {...props.searchProps}
                  placeholder="ชื่อ,สถานะ,วันที่,..."
                />
              </div>

              <hr />
            </div>
          )}
        </ToolkitProvider>
        </div>
        <div
          id="ssd"
          style={{
            width: "100%",
            top: "55px",
            left: "0px",
            position: "absolute",
          }}
        ></div>
      </div>
      {/* {showInfomation === true && ( */}
      <Modal
        show={showInfomation}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            ลำดับที่ {selectedInformation[0]} รหัสการปฏิบัติการ{" "}
            {selectedInformation[1]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ margin: "0", padding: "0" }}>
          <div
            style={{
              width: "100%",
              height: "600px",
              backgroundColor: "black",
            }}
            ref={mapRef}
          ></div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ width: "100%", height: "100%" }}>
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                style={{ width: "50%", height: "100%", textAlign: "center" }}
              >
                <h4>ผู้ใช้ : {selectedInformation[2]} </h4>
              </div>
              <div
                style={{ width: "50%", height: "100%", textAlign: "center" }}
              >
                <h4>ผู้อนุญาติ : -</h4>
              </div>
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                style={{ width: "50%", height: "100%", textAlign: "center" }}
              >
                <h4>เวลาเริ่มต้น : {selectedInformation[3]}</h4>
              </div>
              <div
                style={{ width: "50%", height: "100%", textAlign: "center" }}
              >
                <h4>เวลาสิ้นสุด : {selectedInformation[4]}</h4>
              </div>
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "30%",
                  height: "100%",

                  textAlign: "center",
                }}
              >
                <h4>
                  {/* จำนวนโดรน : {JSON.parse(selectedInformation[5]).length} */}
                </h4>
              </div>
              <div
                style={{ width: "30%", height: "100%", textAlign: "center" }}
              >
                <h4>
                  {/* จำนวนนักบิน : {JSON.parse(selectedInformation[6]).length} */}
                </h4>
              </div>
              <div
                style={{ width: "30%", height: "100%", textAlign: "center" }}
              >
                {/* <h4>ความสูง : {selectedInformation[7].toString()}</h4> */}
              </div>
            </div>
            {approveStage === "" ? (
              <div style={{ display: "flex" }}>
                {selectedInformation[4] === "อนุมัติ" ? (
                  <button className="modal-button-already-approve" disabled>
                    อนุมัติ
                  </button>
                ) : (
                  <button
                    onClick={() => setApproveStage("อนุมัติ")}
                    className="modal-button-approve"
                  >
                    อนุมัติ
                  </button>
                )}
                {/* {(selectedInformation[4] === "ส่งอนุมัติ") |
                  (selectedInformation[4] === "อยู่ระหว่างการพิจารณา") ? (
                    <button
                      className="modal-button-already-standby"
                      // onClick={handleClose}
                      disabled
                    >
                      รอทำการ
                    </button>
                  ) : (
                    <button
                      className="modal-button-standby"
                      // onClick={handleClose}
                      onClick={() => setApproveStage("รอทำการ")}
                    >
                      รอทำการ
                    </button>
                  )} */}
                {selectedInformation[4] === "ไม่อนุมัติ" ? (
                  <button
                    className="modal-button-already-unapprove"
                    // onClick={handleClose}
                    disabled
                  >
                    ไม่อนุมัติ
                  </button>
                ) : (
                  <button
                    className="modal-button-unapprove"
                    // onClick={handleClose}
                    onClick={() => setApproveStage("ไม่อนุมัติ")}
                  >
                    ไม่อนุมัติ
                  </button>
                )}
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <button
                  className="modal-button-confirm"
                  onClick={() => {
                    handleSendupdate(approveStage);
                    setApproveStage("");
                    handleClose();
                  }}
                >
                  ยืนยัน
                </button>
                {/* {approveStage === "อนุมัติ" && (
                    <button className="modal-button-already-approve" disabled>
                      {approveStage}
                    </button>
                  )}
                  {approveStage === "รอทำการ" && (
                    <button className="modal-button-already-standby" disabled>
                      {approveStage}
                    </button>
                  )}
                  {approveStage === "ไม่อนุมัติ" && (
                    <button className="modal-button-already-unapprove" disabled>
                      {approveStage}
                    </button>
                  )} */}
                <button
                  className="modal-button-cancel"
                  onClick={() => {
                    setApproveStage("");
                    //handleClose()
                  }}
                >
                  ยกเลิก
                </button>
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
      {/* )} */}
    </div>
  );
}

export default RegulatorStatusflightDrone;
